module.exports = __webpack_public_path__ + "static/media/event8.0141c6e0.jpg";